<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <date-field
          v-model="flightInfo.date"
          field-name="date"
          :events="flight_dates"
          rules="required|date"
          autofocus
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="flightInfo.plane_id"
          field-name="reg_num"
          source-type="planes"
          filter="plc_01"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="flightInfo.pic_id"
          field-name="pic"
          source-type="pilots"
          :disabled="!daily_flight_operator"
          alter="ident"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="flightInfo.sic_id"
          field-name="sic"
          source-type="pilots"
          rules=""
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
      >
        <airport-selector
          v-model="flightInfo.takeoff_airport_id"
          field-name="takeoff_airport"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <airport-selector
          v-model="flightInfo.landing_airport_id"
          field-name="landing_airport"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <time-field
          v-model="flightInfo.first_takeoff_time"
          field-name="first_takeoff_time"
          rules="required|time"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <time-field
          v-model="flightInfo.last_landing_time"
          field-name="last_landing_time"
          rules="required|time"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <validated-text-field
          v-model="flightInfo.first_takeoff_counter"
          field-name="first_takeoff_counter"
          rules="required"
          type="number"
          step="0.01"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <validated-text-field
          v-model="flightInfo.last_landing_counter"
          field-name="last_landing_counter"
          rules="required"
          type="number"
          step="0.01"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="flightInfo.landing"
          field-name="landing"
          rules="required|numeric|min_value:1|max_value:50"
          type="number"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="flightInfo.task_id"
          field-name="task_id"
          source-type="tasks"
          translate
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <validated-text-field
          v-model="flightInfo.comment"
          field-name="comment"
          rules="max:500"
          type="text"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { call, get } from 'vuex-pathify'

  export default {
    name: 'EditFlightGeneralMultiple',
    props: {
      flightInfo: Object,
      privateRecord: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        flight_dates: [],
      }
    },
    computed: {
      profile: get('auth/profile'),
      daily_flight_operator () { return this.profile.has_role.daily_flight_operator },
    },
    mounted () {
      this.fetchDatasource({ sourceType: 'flight-dates' }).then(response => {
        this.flight_dates = response.map(m => m.date) //  { date: '2021-15-15', events: ['2021-15-15'] }
      })
    },
    methods: {
      fetchDatasource: call('datasource/fetchDatasource'),
    },
  }
</script>
